"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'company.tooltips.preview': '预览公司详情',
};
